"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trimText = void 0;
const MAX_TEXT_LENGTH = 250;

/**
 * The `trimString` function takes a long string as input and returns a trimmed version of it if its
 * length exceeds 255 characters.
 * @param {string} text - The `trimString` function takes a `text` parameter, which is
 * expected to be a string. The function checks if the length of the `text` is greater than 255
 * characters. If it is, the function returns the first 255 characters of the `text`, otherwise
 * @returns If the length of the `text` is greater than 255 characters, the function will
 * return the first 255 characters of the `text`. Otherwise, it will return the original
 * `text` unchanged.
 */
const trimText = text => {
  const numberOfChars = text.length;
  let trimmed = text.slice(0, MAX_TEXT_LENGTH);
  if (numberOfChars > MAX_TEXT_LENGTH) {
    // And still show how many chars are actually there
    trimmed += `... (+${numberOfChars - MAX_TEXT_LENGTH})`;
  }
  return trimmed;
};
exports.trimText = trimText;
